import Welcome from "./Welcome";

const Main=()=>{
    return(
        <div >
            <Welcome/>
        </div>
    )
}
export default Main;